import Lottie from "lottie-react";
import { useNavigate } from "react-router-dom";

import styles from "./style.module.css";
import iStyles from "./iStyles.module.css";
import LoadingAnimation from "./loader_animation.json";
import { getMobileOperatingSystem, triggerEvent, wRatio } from "../../constants/utils";
import TestimonialCard from "../Premium/TestimonialCard";
import UserReviews from "../../../screens/PremiumScreen/UserReviews";
import ContentTags from "../../../assets/payment_screen/content_tags.webp"
import Partners from "../../../assets/adhd/Frame 1000003327.webp"
import { useState, useRef, useEffect } from "react";
import ActionButton from "../../../procastination_flow/components/ActionButton";

const ScorePreparation = () => {
  const navigate = useNavigate();
  const isiOS = getMobileOperatingSystem() === "iOS";
  const [showBtn, setShowBtn] = useState(false);
  
  const handleNavigation = () => {
    navigate("/phone_screen")
  }

  useEffect(() => {
    triggerEvent("Score_Prep_Screen");
  }, []);

  useEffect(()=>{
    const interval = setInterval(()=>{
      setShowBtn(true);
      clearInterval(interval);
    }, 8000);

    return ()=>clearInterval(interval);
  }, [])

  return (
    <div className={styles.ScorePreparationContainer}>
      <p
        className={isiOS ? iStyles.PrepareScoreTitle : styles.PrepareScoreTitle}
      >
        Creating a personalised ADHD routine for you
      </p>
      <p
        className={
          isiOS ? iStyles.PrepareScoreSubTitle : styles.PrepareScoreSubTitle
        }
      >
        We are analysing your responses to create a routine that suits you{" "}
      </p>

      <div className={styles.UserReviewsStyle}>
        < UserReviews />
      </div>
      
      
      {/* <div>
        <img src={ContentTags} alt="" className={styles.ContentTags}/>
      </div> */}

      <div className={styles.BottomContainer}>
        <img
          src={require("../../images/cloud3.webp")}
          className={styles.Cloud3}
        />
        <div className={styles.OverlayContent}>
          <p
            className={
              isiOS ? iStyles.PrepareScoreTitle : styles.PrepareScoreTitle
            }
          >
            Our Partners
          </p>
          <br/>
          <div className={styles.ImageWrapper}>
            <img src={Partners} alt="" className={styles.ContentTags}/>
          </div>
        </div>
        <div className={styles.ActionArea}>
            {showBtn ? (<ActionButton
              buttonStyle={{zIndex:3, marginBottom: '3rem'}}
              text={"Continue"}
              disabled={false}
              onClick={handleNavigation}
              />) : (<div className={styles.Loader}>
              <Lottie
                animationData={LoadingAnimation}
                loop={false}
                style={{
                  width: 467 * wRatio,
                }}
              />
            </div>)}
        </div>
        
      </div>
    
    </div>
  );
};

export default ScorePreparation;
